import { Lot } from './lot';
import { Note } from './note';

export class ChangeOrderLot {
    public id: number;
    public jobChangeOrderId: number;
    public lot: Lot;
    public overrideNoteId: number;
    public action: string;
    public revertToDirt: boolean;
    public overrideNote: Note;
}